import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CONFIG } from '../helpers/config';
import Bowser from 'bowser';

type RouteParams = {
  invite_code: string;
};

export const Main = () => {
  const { invite_code } = useParams<RouteParams>();

  useEffect(() => {
    if (invite_code) {
      createTempUserSession();
    }
    // eslint-disable-next-line
  }, [invite_code]);

  const createTempUserSession = async () => {
    try {
      await fetch(`${CONFIG.BASE_URL}onboarding/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: invite_code,
        }),
      });
      redirectToStore();
    } catch (error) {
      redirectToStore();
    }
  };

  const redirectToStore = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const platformType = browser.getPlatformType(true);
    const osName = browser.getOSName(true);

    if (platformType === 'mobile' || platformType === 'tablet') {
      if (osName.includes('android')) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.ippopay';
        return;
      }
      if (osName.includes('ios')) {
        window.location.href = 'https://apps.apple.com/in/app/ippopay/id6753315070';
        return;
      }
    }
    window.location.href = 'https://play.google.com/store/apps/details?id=com.ippopay';
  };

  return <div>Please wait while we are redirecting you to Ippopay app...</div>;
};
